import { useEffect, useState } from 'react'
import { Square, Volume2 } from 'lucide-react'
import { lees, stemmenZoeken, stop } from '../lib/voorlezen'

/* ===========================================================================
 *  De voorleesknop
 *
 *  Hij is er alleen als hij iets kan. Staat er geen Nederlandse stem op het
 *  toestel, dan verschijnt er niets -- zie de kop van lib/voorlezen.ts voor
 *  waarom dat beter is dan een knop die Nederlands met een Engelse tong
 *  voorleest.
 *
 *  Hij stopt uit zichzelf bij het verlaten van de module. Zonder dat praat de
 *  vorige module door terwijl je de volgende leest, en dan is er geen knop meer
 *  om hem stil te krijgen -- die hoorde bij het scherm dat je net verliet.
 * =========================================================================== */

export default function Voorlezen({ tekst }: { tekst: string }) {
  const [stem, setStem] = useState<SpeechSynthesisVoice | null>(null)
  const [bezig, setBezig] = useState(false)

  useEffect(() => stemmenZoeken(setStem), [])

  /* Weg van dit scherm betekent: stil. */
  useEffect(() => () => stop(), [])

  /* Een nieuwe tekst is een nieuwe module. Wat er nog uit de vorige klonk,
     hoort daar te stoppen. */
  useEffect(() => {
    stop()
    setBezig(false)
  }, [tekst])

  if (!stem) return null

  function aan() {
    if (!stem) return
    setBezig(true)
    lees(tekst, stem, () => setBezig(false))
  }

  function uit() {
    stop()
    setBezig(false)
  }

  return (
    <button
      type="button"
      className={`knop klein voorlees ${bezig ? 'bezig' : ''}`}
      onClick={bezig ? uit : aan}
      title={bezig ? 'Stoppen' : `Laat deze module voorlezen (${stem.name})`}
    >
      {bezig ? <Square size={14} /> : <Volume2 size={15} />}
      {bezig ? 'Stop' : 'Voorlezen'}
    </button>
  )
}
